module.exports = __webpack_public_path__ + "img/cup.54b70256.svg";